import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Chip, Grid, IconButton, TextField, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { withStyles } from "@mui/styles";
import { Styles } from '../../../../styles/material-styles';
import DeleteIcon from '@mui/icons-material/Delete';
import * as LLMKeywordService from "../../../../services/llmkeyword.service";
import { NotificationVariant } from "src/utils/enums/notification-variants.enum";

const EventDynamicAccordion = (props) => {
    const {
        llm,
        llmEvent,
        onShowNotification,
        onLoading,
        classes, 
        intl,
        onHandleDeleteEvent
    } = props;

    const [loadData, setLoadData] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const [keywords, setKeywords] = useState([]);

    const handleChange = async (event, isExpanded) => {
        setExpanded(isExpanded);
    };

    const fetchData = async () => {
        if (llm && llmEvent) {
            setLoadData(true);

            try {
                const response = await LLMKeywordService.getAllLLMKewWordByLlmAndLlmEvent(llm?.id, llmEvent?.id);
                if (response?.success) {
                    var data = response?.data;
                    if (data?.length > 0) {
                        let kws = data?.map(item => item?.keyword);
                        setKeywords(kws);
                    }
                } else {
                    onShowNotification("Não foi recuperar as palavras chaves.", NotificationVariant.ERROR);
                }
            } catch (err) {
                onShowNotification("Não foi recuperar as palavras chaves.", NotificationVariant.ERROR);
            } finally {
                onLoading(false);
            }
        }
    }
    
    const handleSubmit = async (event) => {
        onLoading(true);
        event.preventDefault();

        try {
            const payload = {
                llmId: llm?.id,
                llmEventId: llmEvent?.id,
                keywords
            };

            const response = await LLMKeywordService.updateByLLMAndEvent(payload);

            if (response?.success === true) {
                onShowNotification(intl.formatMessage({ id: "add.success" }));
            } else {
                onShowNotification("Não foi possível adicionar as palavras chaves.", NotificationVariant.ERROR);
            }
        } catch (err) {
            console.error(err);
            onShowNotification("Não foi possível adicionar as palavras chaves.", NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    useEffect(() => {
        if (expanded && !loadData) {
            fetchData();
        }
    }, [expanded]);

    return (
        <Accordion expanded={expanded} onChange={handleChange}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{
                borderLeft: '5px solid #3f51b4',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                padding: '10px 20px',
                backgroundColor: '#f9f9f9',
            }}>
                <Typography variant="h6">{llmEvent?.name}</Typography>
            </AccordionSummary>
            <AccordionDetails style={{ marginTop: '20px' }}>
                <div className={classes.paper} style={{ marginTop: 0 }}>
                    <form name='myForm' className={classes.form} onSubmit={handleSubmit} encType='multipart/form-data'>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <Autocomplete
                                    multiple
                                    id="tags-filled"
                                    options={[]}
                                    freeSolo
                                    value={keywords}
                                    onChange={(event, newValue, reason) => {
                                        setKeywords(newValue);
                                    }}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => {
                                            const { key, ...tagProps } = getTagProps({ index });
                                            return <Chip variant="outlined" label={option} key={key} {...tagProps} />;
                                        })
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params} variant="filled" label={intl.formatMessage({ id: "keywords" })} />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                                <Grid container>
                                    <Grid item xs={12} sm={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <IconButton 
                                            aria-label="delete" 
                                            color="error"
                                            onClick={() => onHandleDeleteEvent(llmEvent)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>

                                        <Button
                                            type='submit'
                                            variant='contained'
                                            color='primary'
                                            className={classes.submit}
                                            size="small"
                                        >
                                            {<FormattedMessage id="save" />}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </form>   
                </div>  
            </AccordionDetails>
        </Accordion>
    )
}

export default injectIntl(withStyles(Styles)(EventDynamicAccordion));